import Resource from '@/plugins/sdk/Resource'
import { BOOLEAN, DATETIME, STRING, UUID, ITEM, COLLECTION } from '@/plugins/sdk/fields'
import TimeZone from '@/plugins/sdk/resources/TimeZone'
import Team from '@/plugins/sdk/resources/Team'
import Role from '@/plugins/sdk/resources/Role'
import Portfolio from '@/plugins/sdk/resources/Dictionary/Portfolio'
import Store from '@/store'
import DefaultConfiguration from '@/store/default-configuration.js'
import { SET_CONFIGURATION } from '@/store/mutation-types'
import Session from './Session'

export default class extends Resource {
  static name = 'profile'
  static label = 'name_full'

  static get fields () {
    return {
      id: new UUID(),
      email: new STRING(),
      name_display: new STRING(),
      name_full: new STRING(),
      position: new STRING(),
      phone_primary: new STRING(),
      phone_secondary: new STRING(),
      deleted: new BOOLEAN(),
      deleted_date: new DATETIME(),
      time_zone: new ITEM(TimeZone),
      team: new ITEM(Team),
      teams: new COLLECTION(Team),
      roles: new COLLECTION(Role),
      application_configuration: new STRING(),
      portfolios: new COLLECTION(Portfolio),
      sessions: new COLLECTION(Session),
      has_set_password: new BOOLEAN(),
      freshdesk_key: new STRING(),
      email_hash: new STRING(),
      sso_only: new BOOLEAN(),
      firebase_id: new STRING(),
      application: new BOOLEAN(),
      freshworks_id: new STRING(),
      expires_at: new DATETIME()
    }
  }

  get name () {
    return this.$fields.name_display.current || this.$fields.name_full.current
  }

  loadConfiguration () {
    if (this.$fields.application_configuration.current) {
      Store.commit(`configuration/${SET_CONFIGURATION}`, JSON.parse(this.$fields.application_configuration.current))
    } else {
      Store.commit(`configuration/${SET_CONFIGURATION}`, DefaultConfiguration)
    }
  }

  async saveConfiguration () {
    this.$fields.application_configuration.current = JSON.stringify(Store.getters.configuration)
    await this.update()
  }

  static get sortables () {
    return [
      { field: 'name_full', label: 'Name' },
      { field: 'email', label: 'Email' },
      { field: 'position', label: 'Position' },
      { field: 'updated_at', label: 'Last Updated' },
      { field: 'created_at', label: 'Date Created' }
    ]
  }
}
